import { Box,Button,Flex,Select,InputGroup,UnorderedList, ListItem,
  InputLeftElement,Input, Heading, Text, Switch,
  TableContainer,Table,Thead,Tbody,Th,Tr,Td, GridItem, Image, Textarea } from "@chakra-ui/react";
import { FaRegFile as FileIcon,FaTimes as CancelIcon } from "react-icons/fa";
import { TopDisplay,UploadButton } from "../../../components";
import { BsDownload as DownloadIcon } from "react-icons/bs";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect, useMemo} from "react";
// import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Formik,Form,Field } from "formik";
import {TablePopUp} from '../../../components';
import { MdMoreVert as MoreIcon } from "react-icons/md";
import { BatchInvite } from "./Modal";
import { Loader } from "../../../customs";
import { FcInvite as InviteIcon} from "react-icons/fc";
import apiCall from '../../../utils/apiCall';
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import { useDropzone } from 'react-dropzone';
import apiCallFormData from '../../../utils/apiFormDataCall';
import { BsUpload as UploadIcon} from "react-icons/bs";
import {
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
} from '@chakra-ui/react'
import {useAtom,atom} from 'jotai'
import { modalAtom, openAtom, notificationAtom, openNAtom } from "../../../context";
import { format } from "date-fns";
import * as Yup from 'yup';
import styled from "@emotion/styled";



const src=`/public-assets/upload_icon.png`;

const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`

export default function Induction() {
  const [hide,set_hide] = useState<boolean>(true);
  const [activeIndex] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [selected_status,set_selected_status] = useState<null | string>(null);

  const [search, set_search] = useState('');
  const [debounced_search, set_debounced_search] = useState('');
  const itemsPerPage = 100;
  const [pageNumber, set_pageNumber] = useState(1);

  // Debounce the search box so typing doesn't fire a request per keystroke.
  useEffect(() => {
    const timer = setTimeout(() => set_debounced_search(search.trim()), 300);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    set_pageNumber(1);
  }, [debounced_search]);

  const isSearching = !!debounced_search;

  // Normal browsing: one request per page, server applies PageNumber/PageSize.
  const { data: pagedResult, isLoading: isLoadingPage } = useQuery(
    ['induction-page', pageNumber],
    async () => {
      const res = await apiCall().get(
        `/Exam/students/dueForInduction?PageNumber=${pageNumber}&PageSize=${itemsPerPage}`
      );
      return res.data;
    },
    {
      enabled: !isSearching,
      keepPreviousData: true,
      select: (data: any) => ({
        items: data?.reportItems || [],
        totalCount: data?.TotalCount ?? (data?.reportItems || []).length,
        pageCount: data?.PageCount ?? 1,
      }),
    }
  );

  // This endpoint has no server-side search param, so search needs to match
  // across every record - only pull every page (batched) while the user is
  // actually typing a search, instead of on every normal page load.
  const { data: searchAllData, isLoading: isLoadingSearchAll } = useQuery(
    ['induction-search-all'],
    async () => {
      const fetchPageSize = 1000;
      const first = await apiCall().get(`/Exam/students/dueForInduction?PageNumber=1&PageSize=${fetchPageSize}`);
      let items = first.data?.reportItems || [];
      const totalPages = first.data?.PageCount || 1;

      if (totalPages > 1) {
        const remainingPages = [];
        for (let page = 2; page <= totalPages; page++) remainingPages.push(page);

        const batchSize = 5;
        for (let i = 0; i < remainingPages.length; i += batchSize) {
          const batch = remainingPages.slice(i, i + batchSize);
          const responses = await Promise.all(
            batch.map((page) => apiCall().get(`/Exam/students/dueForInduction?PageNumber=${page}&PageSize=${fetchPageSize}`))
          );
          responses.forEach((res) => {
            items = [...items, ...(res.data?.reportItems || [])];
          });
        }
      }

      return items;
    },
    {
      enabled: isSearching,
      staleTime: 5 * 60 * 1000,
    }
  );

  const filteredSearch = useMemo(() => {
    if (!isSearching) return [];
    const term = debounced_search.toLowerCase();
    return (searchAllData || []).filter((eData: any) =>
      Object.values(eData).join(' ').toLowerCase().includes(term)
    );
  }, [searchAllData, debounced_search, isSearching]);

  const currentItems = isSearching
    ? filteredSearch.slice((pageNumber - 1) * itemsPerPage, pageNumber * itemsPerPage)
    : (pagedResult?.items || []);
  const totalCount = isSearching ? filteredSearch.length : (pagedResult?.totalCount ?? 0);
  const pageCount = isSearching
    ? Math.max(1, Math.ceil(filteredSearch.length / itemsPerPage))
    : (pagedResult?.pageCount ?? 1);
  const isLoading = isSearching ? isLoadingSearchAll : isLoadingPage;
  const itemOffset = (pageNumber - 1) * itemsPerPage;
  const endOffset = Math.min(itemOffset + itemsPerPage, totalCount);

  const handlePageClick = (event: any) => {
    set_pageNumber(event.selected + 1);
  };

  const handleReload = () => {
    set_search('');
    set_pageNumber(1);
  };


  const showBatchInvite = () =>{
    set_modal({
      header:'Send Batch Invite ',
      content:<BatchInvite/>
    })
    set_open(true);
  }
  
  const showUploadOldInductee = () =>{
    set_modal({
      header:'Upload Old Inductees',
      content:<UploadOldInductee />
    })
    set_open(true);
  }
  const showDownloadTemplate = () =>{
    set_modal({
      header:'Downoad Excel Template ',
      content:<ViewDownloadTemplate />
    })
    set_open(true);
  }

  return (
    <>
   {isLoading?<Loader />:

    <Box>
      <TopDisplay label="Inductee List" button_array={[
          <Button  bg="var(--dark-green-color)" color="var(--white-color)"  leftIcon={<InviteIcon/>}     variant="outline"
            colorScheme="var(--dark-green-color)"
            onClick={showBatchInvite}
          >Send Batch Invite</Button>,
          <Button  bg="var(--dark-green-color)" color="var(--white-color)"  leftIcon={<UploadIcon/>}     variant="outline"
            colorScheme="var(--dark-green-color)"
            onClick={showUploadOldInductee}
          >Upload Old Students</Button>,
          <Button variant="outline"  bg="var(--white-color)" color="var(--darek-green-color)"  leftIcon={<DownloadIcon/>}  
          colorScheme="var(--dark-green-color)"
          onClick={showDownloadTemplate}
        >Download Template</Button>,
         
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
         <InputGroup h="40px" width="300px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
          <InputLeftElement pointerEvents='none'>
            <SearchIcon color='gray.300' />
          </InputLeftElement>
          <Input value={search} onChange={(e: any) => set_search(e.target.value)} type='text' placeholder='search' />
          <span
            style={{
              position: 'absolute',
              zIndex: '1',
              right: '10px',
              cursor: 'pointer',
              top: '12px'
            }}
            onClick={handleReload} // ✅ Reload logic
          >
            <ReloadIcon />
          </span>
        </InputGroup>
          {/* <Select placeholder="Status" width="130px" bg="var(--white-color)" 
            borderColor="var(dark-green-color)" onChange={(e:any)=>set_selected_status(e.target.value)}>
              <option value="Applied for Induction">Applied for Induction</option>
              <option value="Invited for Induciton">Invited for Induction</option>
              <option value="Inducted">Inducted</option>
              <option value="Due for Induction">Due for Induction</option>

          </Select> */}

        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
          <Heading m="0" fontSize="1rem">All Induction invites</Heading>
          <Text m="0" fontSize=".8rem">Showing {totalCount === 0 ? 0 : itemOffset + 1} - {endOffset} of {totalCount}</Text>
        </Flex>
     {  currentItems && currentItems.length > 0 ? <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
              <Th sx={HeadStyle}>First Name</Th>
                <Th sx={HeadStyle}>Last Name</Th>
                <Th sx={HeadStyle}>Student No</Th>
                <Th sx={HeadStyle}>IsInvited</Th>
                <Th sx={HeadStyle}>HasApplied</Th>
                <Th sx={HeadStyle}>IsOldStudent</Th>
                <Th sx={HeadStyle}>Ismoved</Th>
                <Th sx={HeadStyle}>NewMembershipNo</Th>
                <Th sx={HeadStyle}>Status</Th>

                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eCandidate:any,index:number) =><ROWSTYLE key={eCandidate.StudentNo}>
                <Td sx={DataStyle}>{eCandidate.FirstName || 'N/A'}</Td>
                <Td sx={DataStyle}>{eCandidate.LastName || 'N/A'}</Td>
                <Td sx={DataStyle}>{eCandidate.StudentNo || 'N/A'}</Td>
                <Td sx={DataStyle}>{eCandidate.IsInvitedForInduction?'Yes':'No'}</Td>
                <Td sx={DataStyle}>{eCandidate.HasAppliedForInduction?'Yes':'No'}</Td>
                <Td sx={DataStyle}>{eCandidate.IsOldStudent?'Yes': 'No'}</Td>
                <Td sx={DataStyle}>{eCandidate.IsMovedToMembership ?'Yes':'No'}</Td>
                <Td sx={DataStyle}>{eCandidate.FinalMembershipNo?'Yes':'No'}</Td>
                <Td sx={DataStyle}>{eCandidate.Status}</Td>
                <Td sx={DataStyle} minW="60px" w="50px" h="50px">
                    <div className={activeIndex === index?'active':''}><Option {...{index,candidate:eCandidate}}/></div>
                </Td>
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No Pending Inductee'  
      }
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>

    </Box>
}
</>
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}

const Option = (props:any)=>{
  const index = props.index;
  const candidate= props.candidate;
  const [ind,set_index] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom)
  const onClick=()=>{
    if(index === ind){
      set_index(null);
      return;
    }
    set_index(index);
  }
  const handleShowProfile = () =>{
    set_index(null);
    set_modal({
      header:'View Details',
      content:<ViewProfile candidate={candidate} />
    })
    set_open(true);
  }

  const handleSingleInvite = () =>{
    set_index(null);
    set_modal({
      header:'Send Invite',
      content:<ViewSingleInvite {...candidate} />
    })
    set_open(true);
  }
  useEffect(()=>{
    return ()=>set_index(null)
  },[])
  return(
    <Popover>
    <PopoverTrigger>
      <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
    </PopoverTrigger>
    <PopoverContent width="fit-content">
      <PopoverArrow />
      <PopoverBody>
        <Grid templateColumns="1fr" p="6px">
          <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>View Details</GridItem>
          {/* <GridItem sx={sx} p="8px 4px">View Details</GridItem> */}
          <GridItem sx={sx} p="8px 4px" onClick={handleSingleInvite}>Send Invite</GridItem>
        </Grid>
      </PopoverBody>
    </PopoverContent>
  </Popover>
  )
}

const ViewProfile = (props:any) =>{
  return(
  <Flex flexDir="column" minWidth="600px" gap="50px">
    <Flex align="center" gap="20px">
      {/* <Image
        src="/public-assets/profile.png"
        width="150px"
        height="150px"
        objectFit="contain"
        objectPosition="center"
        alt="profile"
      /> */}
      <Flex gap="20px">
        {/* <Heading fontSize="1rem">{props.candidate.FirstName+" "+props.candidate.LastName}</Heading> */}
        <Text width="150px"  fontWeight="500" color="var(--light-text)">First Name</Text>
        <Text> {props.candidate.FirstName}</Text>
      </Flex>
    </Flex>
    <Grid templateColumns="1fr" templateRows="repeat(3,1fr)" gap="30px">
     
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Last Name</Text>
        <Text fontWeight="500">{props.candidate.LastName || 'N/A'}</Text>
      </GridItem>
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">StudentNo</Text>
        <Text fontWeight="500">
          {props.candidate.StudentNo || 'N/A'}
        </Text>
      </GridItem >
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">IsInvited</Text>
        <Text fontWeight="500">
          {props.candidate.IsInvitedForInduction?'YES' : 'NO'}
        </Text>
      </GridItem >
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">HasApplied</Text>
        <Text fontWeight="500">
          {props.candidate.HasAppliedForInduction? 'YES':'NO'}
        </Text>
      </GridItem >
      {/* <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">IsOldStudent</Text>
        <Text fontWeight="500">
          {props.eCandidate.IsOldStudent?'Yes': 'No'}
        </Text>
      </GridItem > */}
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">IsMoved</Text>
        <Text fontWeight="500">
          {props.candidate.IsMovedToMembership?'YES':'No'}
        </Text>
      </GridItem >
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">NewMemberNo</Text>
        <Text fontWeight="500">
          {props.candidate.FinalMembershipNo || 'N/A'}
        </Text>
      </GridItem >
      
    </Grid>
  </Flex>
  )}
  const AddSchema = Yup.object({
    InductionName:Yup.string().required(),
    InductionVenue:Yup.string().required(),
    InductionDate:Yup.date().required(),
   
  });

  const Label = styled.label``;  

  const ViewSingleInvite = (props:any) =>{
    // console.log({...props},'data')
    const queryClient = useQueryClient();
    const [,set_open] = useAtom(openAtom);
    const [,set_N_open] = useAtom(openNAtom);
    const [,set_notification] = useAtom(notificationAtom);


    const {mutate:sendInduction,isLoading} = useMutation({
      mutationKey:['new-batch-induction-invite'],
      mutationFn:async (payload:any)=> {
        await apiCall().post(`/exam/BatchExamInductionInvite`,payload)
        .then(async function(data:any){
          //console.log(data,'response data');
         
          set_open(false);
          //(data,'success data')
          set_notification({
            type:'success',
            message: data.Message || data?.data?.Message || 'Submitted Successfully'
          })
          set_N_open(true);
          queryClient.invalidateQueries({ queryKey: ['induction-page'] });
          queryClient.invalidateQueries({ queryKey: ['induction-search-all'] });
       })
      
      },
      onSuccess:(data:any)=>{
        //console.log(data,'success data')
        set_notification({
          type:'success',
          message: data.Message || data.data.Message || 'Submitted Successfully'
        })
        set_N_open(true);
        queryClient.invalidateQueries({ queryKey: ['induction-page'] });
        queryClient.invalidateQueries({ queryKey: ['induction-search-all'] });
      },
      onError(error:any){
        set_notification({
          type:'error',
          message:error.data.Message || error.Message || 'oops! Error Occured'
        })
        set_N_open(true);
      },
      onSettled:()=>{
        set_open(false);
      }
    } )
    return (
      <>
        <Formik
            initialValues={{
              InductionName:props.InductionName || '',
              InductionVenue:props.InductionVenue || '',
              InductionDate:props.InductionDate || '',
              PaymentDeadlineDate:props.PaymentDeadlineDate || ''

             
            }}
            validationSchema={AddSchema}
            onSubmit={(values:any) => {
            const data:any = {
              StudentNumbers:[
                props.StudentNo,
              ]
              ,
              InductionName:values.InductionName ,
              InductionVenue:values.InductionVenue ,
              InductionDate:values.InductionDate,
              PaymentDeadlineDate:values.PaymentDeadlineDate


              
            };
             
              //console.log(data,'form data')

              sendInduction(data);
            }}
          >
           {(formik:any)=>{
          const {values} = formik;
          
          
          return (
              <Form>
                <Flex flexDir={"column"} align={"center"} gap="20px">
                  <Flex w="100%" as={Label} flexDir="column" gap="10px" >
                    <span>Induction Name</span> 
                  <Input as={Field} 
                    placeholder="Induction Name"
                    borderColor="green"
                    name="InductionName"
                    type="text"
                  />
                  </Flex>

                  <Flex w="100%" as={Label} flexDir="column" gap="10px" >
                    <span>Induction Venue</span> 
                  <Input as={Field} 
                    placeholder="Induction Venue"
                    borderColor="green"
                    name="InductionVenue"
                    type="text"
                  />
                  </Flex>
                  <Flex w="100%" as={Label} flexDir="column" gap="10px" >
                    <span>Induction Date</span> 
                    <Input as={Field} flex="1"
                    size="md"
                    borderColor="green"
                    name="InductionDate"
                    type="datetime-local"
                  />
                  </Flex>
                   <Flex w="100%" as={Label} flexDir="column" gap="10px" >
                    <span>Payment Deadline Date</span> 
                    <Input as={Field} flex="1"
                    size="md"
                    borderColor="green"
                    name="PaymentDeadlineDate"
                    type="datetime-local"
                  />
                  </Flex>
                  <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading} >
                    {isLoading?"Loading":'Submit'}
                  </Button>
                </Flex>
                  
                
              </Form>
            )}}
          </Formik>
      </>
    )
  }

const UploadSchema = Yup.object({
  Inductee:Yup.mixed()

});
  
  
// const UploadOldInductee = (props:any) =>{
//   // console.log({...props},'data')
//   const queryClient = useQueryClient();
//   const [,set_open] = useAtom(openAtom);
//   const [,set_Nopen] = useAtom(openNAtom);
//   const [,set_notification]= useAtom(notificationAtom);
  
//   const [uploadedFiles, setUploadedFiles] = useState<any>([]);
//   const { getRootProps, getInputProps } = useDropzone({
//     onDrop: (acceptedFiles) => {
//       console.log(acceptedFiles.join(','),'files');
//       setUploadedFiles(acceptedFiles);
//       // Call your backend API endpoint to upload files
//     },
//   });

//   const removeFile=(name:any)=>{
//     setUploadedFiles((files:any[]) => files?.filter(eFile => eFile.name != name));
//   }

//   const {mutate:addUpdate,isLoading} = useMutation({
//     mutationKey:['old-inductees'],
//     mutationFn:async (data:FormData)=> {
//       return await apiCallFormData().post(`/ExamUpload/uploadOldInductee`,data)},
//     onSuccess:(data)=>{
//       set_notification({
//         type:'success',
//         message:data?.data?.Message || 'Uploaded Successfully'
//       })
//       set_Nopen(true);
//       queryClient.invalidateQueries({
//         queryKey:['all-induction']
//       })
//       setUploadedFiles([]);
//     },
//     onError(error:any, variables, context) {
//       set_notification({
//         type:'error',
//         message:error?.data?.Message || 'Error Occured'
//       })
//       set_Nopen(true);
//     },
//     onSettled:()=>{
//       set_open(false);
//     }

//   } )
//   return (
//     <>
//       <Formik
//           initialValues={{
            
//             Inductee: props.Inductee || '',
//           }}
//           validationSchema={UploadSchema}
//           onSubmit={(values:any) => {
//             if(uploadedFiles.length > 0){
//               const data =  new FormData();
//               data.append('Inductee',uploadedFiles[0]);
            
//               addUpdate(data);
//             }
//             else{
//               set_notification({
//                 type:'error',
//                 message:'Select a file'
//               })
//               set_Nopen(true);
//               return;
//             }
            

//           }}
//         >
//           {(formik:any)=>{
//         const {errors} = formik;
//         return (
//             <Form>
//               <Flex flexDir={"column"} align={"center"} gap="20px">             
//                   {/* <Button leftIcon={<UpIcon/>}>Upload document</Button> */}
//                 <Flex flexDir="column" gap="10px" w="100%">
                  
//                     <Box>Upload Document:<br/></Box>             
//                     <Box {...getRootProps()}>
//                       <input {...getInputProps()} name="Inductee" id="file" />
//                       <Image
//                         alt="upload document"
//                         src={src}
//                         w="100%"
//                         h="150px"
//                         objectFit="contain"
//                         objectPosition="center"
//                       />  
//                       <UnorderedList sx={{p:'0',m:'0','listStyleType':'none'}}>
//                       {uploadedFiles?.slice(0,1).map((file:any) => (
//                         <ListItem align="center" gap="10px" as={Flex} sx={{p:'5p 0'}} fontSize="11px" key={file.name}><FileIcon />{file.name} <CancelIcon style={{marginLeft:'auto'}} onClick={()=>removeFile(file.name)} /></ListItem>
//                       ))}
//                     </UnorderedList>                   
//                     </Box>
//                 </Flex>
//                 {/* <Field as={Input} multiple type='file' name="Document" /> */}
//                 <Box>
//                   {errors && Object.values(errors).map((eError:any,index:number)=> <Box color="red" key={index} >{eError}</Box>)}
//                 </Box>
//                 <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading} >
//                     {isLoading?"Loading":'Submit'}
//                 </Button>
//               </Flex>
//             </Form>
//           )}}
//         </Formik>
//     </>
//   )
// }

const UploadOldInductee = (props: any) => {
  const queryClient = useQueryClient();
  const [, set_open] = useAtom(openAtom);
  const [, set_Nopen] = useAtom(openNAtom);
  const [, set_notification] = useAtom(notificationAtom);

  const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);
  const [uploadResponse, setUploadResponse] = useState<any>(null);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      console.log(acceptedFiles, "files");
      setUploadedFiles(acceptedFiles);
    },
  });

  const removeFile = (name: any) => {
    setUploadedFiles((files) => files.filter((file) => file.name !== name));
  };

  // const { mutate: addUpdate, isLoading } = useMutation({
  //   mutationKey: ["old-inductees"],
  //   mutationFn: async (data: FormData) => {
  //     return await apiCallFormData().post(`/ExamUpload/uploadOldInductee`, data, {
  //       responseType: "blob", // Ensure API returns a file if applicable
  //     });
  //   },
  //   onSuccess: async (data) => {
  //     console.log("Upload response:", data);
      
  //     // Check if API response is a file
  //     if (data?.data instanceof Blob) {
  //       const url = window.URL.createObjectURL(new Blob([data.data]));
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", "uploaded_file.pdf"); // Change filename if needed
  //       document.body.appendChild(link);
  //       link.click();
  //       link.remove();
  //       window.URL.revokeObjectURL(url);
  //     } else {
  //       // Handle response if it's a JSON object with file URL
  //       const responseData = JSON.parse(await data.data.text()); // Convert blob to text (if it's JSON)
  //       setUploadResponse(responseData);

  //       if (responseData?.fileUrl) {
  //         window.open(responseData.fileUrl, "_blank");
  //       }

  //       set_notification({
  //         type: "success",
  //         message: responseData?.Message || "Uploaded Successfully",
  //       });
  //     }

  //     set_Nopen(true);
  //     queryClient.invalidateQueries({ queryKey: ["all-induction"] });
  //     setUploadedFiles([]);
  //   },
  //   onError: (error: any) => {
  //     set_notification({
  //       type: "error",
  //       message: error?.data?.Message || "Error Occurred",
  //     });
  //     set_Nopen(true);
  //   },
  //   onSettled: () => {
  //     set_open(false);
  //   },
  // });

 const { mutate: addUpdate, isLoading } = useMutation({
      mutationKey: ['old-inductee'],
      mutationFn: async (data: FormData) => {
        const response = await apiCallFormData().post(`/ExamUpload/uploadOldInductee`, data, {
          responseType: 'blob', // Ensures we handle file downloads properly
        });
        return response;
      },
      onSuccess: async (response) => {
        const contentType = response.headers['content-type'];
  
        if (contentType.includes('application/json')) {
          // ✅ Handle JSON response (success message)
          const data = await response.data.text();
          const parsedData = JSON.parse(data);
  
          set_notification({
            type: 'success',
            message: parsedData?.Message || 'Student Uploaded Successfully',
          });
        } else {
          // ✅ Handle file download
          const blob = new Blob([response.data], { type: contentType });
  
          // 🔹 Extract filename from content-disposition header
          let filename = 'DownloadedFile';
          const disposition = response.headers['content-disposition'];
          if (disposition) {
            const match = disposition.match(/filename="(.+?)"/);
            if (match) filename = match[1];
          }
  
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
  
          set_notification({
            type: 'success',
            message: 'Download Ready',
          });
        }
  
        set_Nopen(true);
        queryClient.invalidateQueries({ queryKey: ['all-old-inductee'] });
        setUploadedFiles([]);
      },
      onError: async (error: any) => {
        let errorMessage = 'Error Occurred';
        try {
          const text = await error.response.data.text();
          const parsedError = JSON.parse(text);
          errorMessage = parsedError?.Message || errorMessage;
        } catch {
          errorMessage = error?.message || errorMessage;
        }
  
        set_notification({
          type: 'error',
          message: errorMessage,
        });
  
        set_Nopen(true);
      },
      onSettled: () => {
        set_open(false);
      },
    });

  return (
    <>
      <Formik
        initialValues={{ Inductee: props.Inductee || "" }}
        validationSchema={UploadSchema}
        onSubmit={(values: any) => {
          if (uploadedFiles.length > 0) {
            const data = new FormData();
            data.append("Inductee", uploadedFiles[0]); // Only uploading the first file
            addUpdate(data);
          } else {
            set_notification({
              type: "error",
              message: "Select a file",
            });
            set_Nopen(true);
            return;
          }
        }}
      >
        {(formik) => {
          const { errors } = formik;
          return (
            <Form>
              <Flex flexDir={"column"} align={"center"} gap="20px">
                <Flex flexDir="column" gap="10px" w="100%">
                  <Box>Upload Document:<br/></Box>
                  <Box {...getRootProps()}>
                    <input {...getInputProps()} name="Inductee" id="file" />
                     <Image
                      alt="upload document"
                      src={src}
                      w="100%"
                      h="150px"
                      objectFit="contain"
                      objectPosition="center"
                    />
                    <UnorderedList sx={{ p: "0", m: "0", listStyleType: "none" }}>
                      {uploadedFiles?.slice(0, 1).map((file) => (
                        <ListItem key={file.name} align="center" gap="10px" as={Flex} sx={{ p: "5px 0" }} fontSize="11px">
                          <FileIcon />
                          {file.name}
                          <CancelIcon style={{ marginLeft: "auto" }} onClick={() => removeFile(file.name)} />
                        </ListItem>
                      ))}
                    </UnorderedList>
                  </Box>
                </Flex>
                <Box>
                  {errors &&
                    Object.values(errors).flatMap((error, index) =>
                      typeof error === "string" ? (
                        <Box color="red" key={index}>
                          {error}
                        </Box>
                      ) : Array.isArray(error) ? (
                        (error as unknown[]) // Explicitly cast to an array
                          .filter((nestedError): nestedError is string => typeof nestedError === "string") // Type predicate
                          .map((nestedError, nestedIndex) => (
                            <Box color="red" key={`${index}-${nestedIndex}`}>
                              {nestedError}
                            </Box>
                          ))
                      ) : null
                    )}
                </Box>



                {/* Display upload response (rejected files or messages) */}
                {uploadResponse && (
                  <Box mt={4} p={3} bg="gray.100" borderRadius="md">
                    <Text fontWeight="bold">Upload Summary:</Text>
                    <UnorderedList>
                      {uploadResponse?.rejectedFiles?.length > 0 ? (
                        uploadResponse.rejectedFiles.map((file: any, idx: number) => (
                          <ListItem key={idx} color="red.500">
                            {file.name} - {file.reason}
                          </ListItem>
                        ))
                      ) : (
                        <Text color="green.500">All files uploaded successfully.</Text>
                      )}
                    </UnorderedList>
                  </Box>
                )}

                <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading}>
                  {isLoading ? "Loading..." : "Submit"}
                </Button>
              </Flex>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};



const DownloadSchema = Yup.object({
  templateType:Yup.string().required(),

});
  
  
const ViewDownloadTemplate = (props:any) =>{
  // console.log({...props},'data')
  
  const [,set_open] = useAtom(openAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
  
  const {mutate:addUpdate,isLoading} = useMutation({
    mutationKey:[],
    mutationFn:async (templateType:string)=> {
      const headers = {
        "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      };
      return await apiCall().get(`/ExamUpload/download/${templateType}`,{
        headers,
        responseType:"blob"

      })},
    onSuccess:async(data:any)=>{
      //initial the download 
     // console.log(data,'download data')
      let file = data?.data;
      console.log(file,'download file');
      if(file){
        const url = window.URL.createObjectURL(new Blob([file]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "template.xlsx");
        document.body.appendChild(link);
        link.click();
        //console.log(file,'data')
        set_notification({
          type:'success',
          message:data?.data?.Message || 'download Successfully'
        })
        set_Nopen(true);
      }
      else{
        set_notification({
          type:'error',
          message:'Oooops! Error Occured trying to download file'
        })
        set_Nopen(true);
      }
      
      
      
    },
    onError(error:any, variables, context) {
      set_notification({
        type:'error',
        message:error?.data?.Message || 'Error Occured'
      })
      set_Nopen(true);
    },
    onSettled:()=>{
      set_open(false);
    }

  } )
  return (
    <>
      <Formik
          initialValues={{
            
            templateType: props.Inductee || '',
          }}
          validationSchema={DownloadSchema}
          onSubmit={(values:any) => {
              if(values.templateType){
                addUpdate(values.templateType);
              }

          }}
        >
          {(formik:any)=>{
        const {errors} = formik;
        return (
            <Form>
              <Flex flexDir={"column"} align={"center"} gap="20px">             
                  {/* <Button leftIcon={<UpIcon/>}>Upload document</Button> */}
                <Flex flexDir="column" gap="10px" w="100%">
                  <Field as={Select} 
                    name="templateType"
                    placeholder="Select Template Type"
                  >
                    <option value="inductee">
                      inductee
                    </option>

                  </Field>
                  <Box color="red">
                    {errors && errors.templateType? errors.tempateType:''}
                  </Box>
                    
                </Flex>
                {/* <Field as={Input} multiple type='file' name="Document" /> */}
                
                <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading} >
                    {isLoading?"Loading":'Submit'}
                </Button>
              </Flex>
            </Form>
          )}}
        </Formik>
    </>
  )
}
